import React from 'react';
import { Alert, Button } from '@mui/material';
import useOrderCheckRetry from '../../hooks/useOrderCheckRetry.hooks';

/**
 * Warning banner with a Retry action, shown when the latest order has gone
 * unconfirmed — no check event within the configured timeout (see
 * useOrderCheckRetry). Clicking Retry resends the current order so the agent
 * no longer has to add/remove a throwaway item to force one.
 */
export default function OrderCheckRetryAlert({
  isUnifiedMenu,
  menuUnificationOrderFailureCallback,
  menuUnificationOrderSuccessCallback,
}: {
  isUnifiedMenu: boolean;
  menuUnificationOrderFailureCallback: Function;
  menuUnificationOrderSuccessCallback: Function;
}) {
  const { isCheckOverdue, retry } = useOrderCheckRetry({
    isUnifiedMenu,
    menuUnificationOrderFailureCallback,
    menuUnificationOrderSuccessCallback,
  });

  if (!isCheckOverdue) {
    return null;
  }

  return (
    <Alert
      severity="warning"
      sx={{ marginBottom: '8px' }}
      action={
        <Button color="inherit" size="small" onClick={retry}>
          Retry
        </Button>
      }
    >
      The POS has not confirmed the order yet
    </Alert>
  );
}
